<template>
  <section class="container match-visualisator">
    <div>
      <b-field grouped>
        <b-field expanded>
          <b-input
            class="score"
            v-model="playerOneScore"
            type="range" step="1" min="-20" max="0" value="0"
            disabled>
          </b-input>
        </b-field>
        <span class="table-filet"></span>
        <b-field expanded>
          <b-input
            class="score"
            v-model="playerTwoScore"
            type="range" step="1" min="0" max="20" value="0"
            style="background-color: white;border: none;"
            disabled>
          </b-input>
        </b-field>
      </b-field>
      <div class="table-foot is-widescreen" expanded>
        <div class="has-text-centered" v-show="statusQuo" expanded>Status-quo!</div>
        <div class="has-text-centered" v-show="gobSlide" expanded>Gob slide!!</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    history: {
      required: true,
      type: Array
    },
    playerOne: {
      required: true,
      type: Number
    },
    playerTwo: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      playerOneScore: 0,
      playerTwoScore: 0,
      index: 0,
      statusQuo: false,
      gobSlide: false,
      speed: 2000
    }
  },
  created () {
    let vm = this
    window.setInterval(function () {
      vm.statusQuo = false
      vm.gobSlide = false
      let log = vm.history[vm.index]
      if (log.type === 'status-quo') {
        vm.statusQuo = true
      }
      if (log.type === 'gob-smash') {
        vm.gobSlide = true
      }

      if (log.userId === vm.playerOne) {
        vm.playerOneScore -= log.point
      } else {
        vm.playerTwoScore += log.point
      }

      vm.index++

      if (vm.index === vm.history.length) {
        vm.index = 0
        vm.playerOneScore = 0
        vm.playerTwoScore = 0
      }
    }, this.speed)
  }
}
</script>

<style scoped>
  .match-visualisator {
    margin: 40px;
  }
  /* @TODO does not twerk */
  .score input {
    -webkit-appearance: none;
    background-color: white !important;
    border: none !important;
  }
  .score::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: none;
    height: 40px;
    width: 30px;
    background: goldenrod;
    background: url(../assets/images/gob.png) no-repeat;
    margin-top: -20px;
  }
  .score::-moz-range-thumb {
    background: url(../assets/images/gob.png) no-repeat;
  }
  .table-filet {
    border-right: solid 1px black;
    height: 28px;
    margin-top: -7px;
  }
  .table-foot {
    height: 40px;
    margin-top: -25px;
    margin-left: 10px;
    margin-right: 10px;
    border-left: solid 1px black;
    border-right: solid 1px black;
  }
</style>



// WEBPACK FOOTER //
// src/components/MatchVisualisator.vue